var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab global_pointer",class:{ selected: _vm.currentTab === _vm.info.type }},[_c('img',{attrs:{"src":_vm.info.icon,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.$t('message.home.'+_vm.info.type)))])])}
var staticRenderFns = []

export { render, staticRenderFns }